import { styled } from '@mui/material';
import type { MouseEvent, ReactNode } from 'react';

export const REMINDER_CARD_LINK_ATTRIBUTE = 'data-reminder-card-link';

type Props = {
  href?: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  children: ReactNode;
};

const linkStyles = {
  color: 'inherit',
  font: 'inherit',
  textAlign: 'inherit',
  textDecoration: 'inherit',
  background: 'none',
  border: 0,
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
  },
  '&:focus-visible': {
    outline: 'none',
  },
} as const;

const TitleAnchor = styled('a')(linkStyles);
const TitleButton = styled('button')(linkStyles);

/**
 * Makes the whole card clickable through a single stretched link on the title,
 * so the card itself never becomes a button wrapping other interactive elements.
 */
export function ReminderCardTitleLink(props: Props) {
  const linkProps = { [REMINDER_CARD_LINK_ATTRIBUTE]: '' };

  if (props.href) {
    return (
      <TitleAnchor href={props.href} onClick={props.onClick} {...linkProps}>
        {props.children}
      </TitleAnchor>
    );
  }

  return (
    <TitleButton type="button" onClick={props.onClick} {...linkProps}>
      {props.children}
    </TitleButton>
  );
}
